<template>
  <AdminLayout>
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <!-- Header -->
      <div class="mb-6 flex items-center gap-3">
        <div class="p-2 bg-[#22282F]/10 rounded-lg">
          <BellRing class="w-7 h-7 text-[#22282F]" />
        </div>
        <div>
          <h1 class="text-2xl sm:text-3xl font-bold text-gray-900">Notifications</h1>
          <p class="text-sm text-gray-500">Qui est prévenu, et de quoi : alertes de sécurité et courriers reçus.</p>
        </div>
      </div>

      <!-- Onglets : une nouvelle notification vient s'ajouter ici, pas dans une page de plus -->
      <div class="flex gap-1 border-b border-gray-200 mb-6 overflow-x-auto" role="tablist">
        <button
          v-for="onglet in ongletsVisibles"
          :key="onglet.id"
          type="button"
          role="tab"
          :aria-selected="actif === onglet.id"
          :data-tab="onglet.id"
          :class="[
            'px-4 py-2.5 text-sm font-medium whitespace-nowrap border-b-2 -mb-px flex items-center gap-2 transition-colors',
            actif === onglet.id
              ? 'border-[#22282F] text-[#22282F]'
              : 'border-transparent text-gray-500 hover:text-[#22282F]',
          ]"
          @click="choisir(onglet.id)"
        >
          <component :is="onglet.icon" class="w-4 h-4" />
          {{ onglet.label }}
        </button>
      </div>

      <AlertesSecuritePanel v-if="actif === 'securite'" />
      <ReceptionAtmPanel v-else-if="actif === 'reception'" />
    </div>
  </AdminLayout>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { BellRing, ShieldAlert, Landmark } from 'lucide-vue-next'
import AdminLayout from '@/layouts/AdminLayout.vue'
import AlertesSecuritePanel from '@/components/notifications/AlertesSecuritePanel.vue'
import ReceptionAtmPanel from '@/components/notifications/ReceptionAtmPanel.vue'
import { useAuthStore } from '@/store/auth'

const route = useRoute()
const router = useRouter()
const authStore = useAuthStore()

const onglets = [
  { id: 'securite', label: 'Alertes de sécurité', icon: ShieldAlert, section: 'securite' },
  { id: 'reception', label: 'Courriers reçus (ATM)', icon: Landmark, section: 'notifications' },
]

// Un profil restreint ne voit que les onglets de ses sections.
const ongletsVisibles = computed(() => onglets.filter((o) => authStore.canSection(o.section)))

const actif = computed(() => {
  const demande = String(route.query.onglet || '')
  return ongletsVisibles.value.find((o) => o.id === demande)?.id ?? ongletsVisibles.value[0]?.id
})

function choisir(id: string) {
  router.replace({ query: { ...route.query, onglet: id } })
}
</script>
